import {
  Cancel,
  InsertDriveFileRounded,
  UploadFileRounded,
} from "@mui/icons-material";
import {
  Box,
  Grid,
  Grow,
  IconButton,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { TransitionGroup } from "react-transition-group";

import "./dropZone.scss";

export default function DropZone({
  maxFiles,
  validator,
  onFiles,
  children,
  helper,
}) {
  const [over, setOver] = useState(false);
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();

  const { getRootProps, getInputProps, acceptedFiles, fileRejections } =
    useDropzone({
      onDragEnter: () => setOver(true),
      onDragLeave: () => setOver(false),
      onDrop: (files) => {
        onFiles?.(files);
        setOver(false);
      },
      validator,
    });

  useEffect(() => {
    let newFiles = helper.files.concat(acceptedFiles);
    // console.log("outer_file",newFiles[0].size);

    if (newFiles.length > maxFiles) {
      newFiles = newFiles.slice(0, maxFiles);
      // console.log("inner_file",newFiles[0].size);

      enqueueSnackbar(`Too many files. Up to ${maxFiles} files are accepted.`, {
        variant: "info",
      });
    }
    helper.setFiles(newFiles);
  }, [acceptedFiles]);
  useEffect(() => {
    helper.setRejections(fileRejections);
  }, [fileRejections]);

  return (
    <Grid container spacing={2} pt={2} pb={2}>
      <Grid item xs={12} sm={12} md={8} zIndex={100}>
        <Paper
          {...getRootProps({ className: "drop-zone" + (over ? " over" : "") })}
          elevation={3}
          sx={{
            color: "primary.dark",
            "--over-color": theme.palette.primary.main,
            [theme.breakpoints.up("md")]: {
              width: helper.files.length > 0 ? "100%" : "150%",
            },
            transition: "width .3s ease-out",
          }}
        >
          <input {...getInputProps()} />
          <UploadFileRounded fontSize="large" color="primary" />
          <Typography variant="body1" component="div" textAlign="center">
            {children}
          </Typography>
          {fileRejections.map(({ file, errors }) => (
            <Typography
              variant="body1"
              component="div"
              color={theme.palette.error.dark}
              key={file.name}
            >
              {file.name} : {errors.map((error) => error.message).join(", ")}
            </Typography>
          ))}
        </Paper>
      </Grid>
      <Grid item xs={12} sm={12} md={4} zIndex={0}>
        <TransitionGroup className="drop-files">
          {helper.files.map((file, index) => (
            <Grow in key={index}>
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: -1,
                }}
              >
                <IconButton
                  onClick={() => {
                    helper.setFiles(helper.files.filter((_, i) => i !== index));
                  }}
                  sx={{ alignSelf: "flex-end" }}
                >
                  <Cancel />
                </IconButton>
                <InsertDriveFileRounded fontSize="large" color="secondary" />
                <Paper
                  sx={{
                    padding: 1,
                    marginTop: 1,
                    maxWidth: 100,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      wordBreak: "break-all",
                      textAlign: "center",
                    }}
                    color="secondary.dark"
                  >
                    {cutIfTooLong(file.name, 30)}
                  </Typography>
                </Paper>
              </Box>
            </Grow>
          ))}
        </TransitionGroup>
      </Grid>
    </Grid>
  );
}

const cutIfTooLong = (str, maxLength) => {
  let ext = str.substr(str.lastIndexOf("."));
  let name = str.substr(0, str.lastIndexOf("."));
  if (str.length > maxLength) {
    return name.substr(0, maxLength - ext.length - 2) + ".." + ext;
  }
  return str;
};
